import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/FloppyDisk.es.js";
const p = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
p.displayName = "FloppyDiskIcon";
const m = p;
export {
  m as FloppyDisk,
  p as FloppyDiskIcon
};
